'use client';

import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { ClientProfilePortalView } from '@/components/portal/ClientProfilePortalView';

export default function MisTurnosPage() {
  const router = useRouter();
  const [business, setBusiness] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadBiz() {
      try {
        const res = await fetch('/api/business?slug=juanrojas');
        const data = await res.json();
        if (data.success && data.business) {
          setBusiness(data.business);
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }
    loadBiz();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  const defaultBiz = business || {
    name: 'Juan Rojas',
    slug: 'juanrojas',
    brandColor: '#4338ca'
  };

  return (
    <ClientProfilePortalView
      business={defaultBiz}
      currentBranch={defaultBiz.branches?.[0]}
      onBackToCatalog={() => router.push(`/${defaultBiz.slug}`)}
      onRescheduleFromProfile={(booking) => {
        const branchSlug = booking.branchSlug || defaultBiz.branches?.[0]?.slug || 'recoleta';
        router.push(`/${defaultBiz.slug}/${branchSlug}`);
      }}
    />
  );
}
